export const worldMap = {
  reset: "reset",
  resetMapSelections: "Reset Map Selections",
  zoomIn: "Zoom In",
  zoomOut: "Zoom Out",
  indicatorPanel: {
    indicatorPanelTitle: "State of Digital Health around the world today",
    noHealthIndicatorAvailable: "No Global Health Indicators Available",
    noDigitalIndicatorAvailable: "No Digital Health Indicators Available",
    viewCountries: "View Countries",
    viewDetails: "View Details",
    context: {
      text: "Context",
      gniPerCapita: "GNI per capita, atlas method (current US$)",
      totalPopulation: "Total population",
      adultLiteracyRate:
        "Adult literacy rate, population 15+ years, both sexes (%)",
      easeOfDoingBusinessIndex: "Ease of doing business index",
    },
    health: {
      text: "Health",
      lifeExpectancy: "Life expectancy at birth (years)",
      healthExpenditure: "Health expenditure (% of GDP)",
      causeOfDeath: "Cause of death, by non-communicable diseases (% of total)",
      mortalityRate: "Mortality rate, under-5 (per 1,000 live births)",
    },
    description:
      "The Global Digital Health Monitor (GDHM) is an interactive web-based resource that aims to track, monitor, and\n" +
      "      assess the enabling environment for digital health throughout the world.",
  },
  searchCountry: "Search Country",
  note: "Made with Natural Earth.",
  note1: "India boundaries",
  note2: "by",
  note3: "DataMeet India community",
};
